/* eslint-disable no-console */

function warn(message) {
  if (typeof console === 'undefined') {
    return;
  }

  console.warn(`[event-hub] ${message}`);
}

export default warn;

export { warn };
